var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoAiProcessing(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 58,
    viewBox: "0 0 53 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.125 26.7344C4.125 22.2298 7.81866 18.5781 12.375 18.5781H22C22.7594 18.5781 23.375 17.9695 23.375 17.2188C23.375 16.468 22.7594 15.8594 22 15.8594H12.375C6.29986 15.8594 1.375 20.7283 1.375 26.7344V45.7656C1.375 51.7718 6.29986 56.6406 12.375 56.6406H31.625C37.7002 56.6406 42.625 51.7718 42.625 45.7656V36.25C42.625 35.4992 42.0094 34.8906 41.25 34.8906C40.4906 34.8906 39.875 35.4992 39.875 36.25V45.7656C39.875 50.2702 36.1813 53.9219 31.625 53.9219H12.375C7.81866 53.9219 4.125 50.2702 4.125 45.7656V26.7344Z",
    fill: "#B8EF36"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.9468 26.6246C18.215 24.7116 14.4375 26.6428 14.4375 29.9524V42.5469C14.4375 45.8565 18.215 47.7878 20.9468 45.8747L29.9392 39.5775C32.2601 37.9522 32.2601 34.5471 29.9392 32.9218L20.9468 26.6246ZM17.1875 29.9524C17.1875 28.8492 18.4467 28.2055 19.3573 28.8432L28.3496 35.1404C29.1233 35.6821 29.1233 36.8172 28.3496 37.3589L19.3573 43.6562C18.4467 44.2938 17.1875 43.6501 17.1875 42.5469V29.9524Z",
    fill: "#B8EF36"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.334 18.1254L38.934 20.2345L41.0673 29.7254L43.2007 20.2345L52.8007 18.1254L43.2007 16.0163L41.0673 6.52539L38.934 16.0163L29.334 18.1254Z",
    fill: "#B8EF36"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5641 10.7391L31.4778 6.44344L27.1328 5.36953L31.4778 4.29563L32.5641 0L33.6503 4.29563L37.9953 5.36953L33.6503 6.44344L32.5641 10.7391Z",
    fill: "#B8EF36"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoAiProcessing);
export default __webpack_public_path__ + "static/media/video_ai_processing.f9b03994ebc558f82eb16b46351fcdb6.svg";
export { ForwardRef as ReactComponent };